import Segment from '../shared/segment';

function TermsAndConditions() {
  return (
    <Segment className='leading-8'>
      <p className='mb-2 text-lg font-medium'>به پنل آزمون گروه مدمشاور خوش آمدید.</p>
      <p>شرایط و قوانین استفاده از مجموعه آنلاین آزمون های گروه مدمشاور</p>
      <p>1. تمامی حقوق مادی و معنوی این سایت برای گروه مدمشاور محفوظ است.</p>
      <p>
        2. هر گونه کپی برداری از محتوای علمی و امکانات فنی این سایت تحت پیگرد قانونی قرار خواهد
        گرفت.
      </p>
      <p>
        3. هر حساب کاربری مختص استفاده تنها یک کاربر بوده و واگذار کردن حساب کاربری به فرد دیگر
        غیرقانونی بوده و در صورت مشاهده، حساب کاربری مسدود خواهد شد.
      </p>
      <p>
        4. بازه زمانی اعتبار بسته های خریداری شده محدود بوده و در زمان خرید بسته به شما نمایش داده
        خواهد شد.
      </p>
      <p>
        5. با توجه به محدودیت های فنی، امکان لغو بسته های خریداری شده و عودت مبلغ وجود ندارد. لطفا
        در انتخاب و خرید بسته های خود دقت نمایید.
      </p>
      <p>
        6. در صورت بروز خطا در هنگام تراکنش بانکی، پس از پیگیری توسط مدیریت سایت و تایید پرداخت شما،
        مبلغ قابل عودت خواهد بود.
      </p>
      <p>
        7. ارتباط با شما از طریق شماره تلفن ثبت شده در حساب کاربری صورت خواهد گرفت. لطفا یک شماره
        تلفن همراه معتبر و در دسترس را در حساب کاربری خود وارد کنید.
      </p>
      <p>
        8. اطلاعات شخصی که هنگام ثبت نام وارد می کنید نزد گروه مدمشاور محفوظ بوده و صرفا جهت بررسی
        های آماری استفاده می گردد. این اطلاعات به سایر کاربران نمایش داده نخواهد شد.
      </p>
      <p>
        9. این صفحه به صورت دوره ای به روز رسانی خواهد شد. خواهشمندیم جهت جلوگیری از مشکلات احتمالی،
        این صفحه را به صورت ماهانه بررسی کنید و از به روزرسانی های شرایط خدمات آگاه شوید.
      </p>
    </Segment>
  );
}

export default TermsAndConditions;
